export default {
	COMPANY: 'COMPANY',
	USER: 'USER',
	VAT: 'VAT',
	ANNUAL_DECLERATION: 'ANNUAL_DECLERATION',
	FINANCIAL_STATEMENT: 'FINANCIAL_STATEMENT'
};
